var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:[_vm.$style.parent, 'mb-0 position-relative']},[_c('img',{class:[_vm.$style.avatar, 'rounded-circle'],attrs:{"src":_vm.runner.avatar,"alt":_vm.runner.fullname,"title":_vm.runner.fullname,"width":_vm.size,"height":_vm.size}}),(_vm.badge)?_c('span',{class:_vm.$style.badge},[_vm._v(_vm._s(_vm.badge))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }